/** @param {number[]} samples */
export function summarizeRenderSamples(samples) {
  if (!samples.length) {
    return { count: 0, mean: 0, p50: 0, p95: 0, max: 0, min: 0 };
  }
  const sorted = [...samples].sort((a, b) => a - b);
  const sum = sorted.reduce((acc, v) => acc + v, 0);
  const pick = p => sorted[Math.min(sorted.length - 1, Math.floor((sorted.length - 1) * p))];
  return {
    count: sorted.length,
    mean: Number((sum / sorted.length).toFixed(2)),
    p50: Number(pick(0.5).toFixed(2)),
    p95: Number(pick(0.95).toFixed(2)),
    max: Number(sorted[sorted.length - 1].toFixed(2)),
    min: Number(sorted[0].toFixed(2))
  };
}

/** @param {import('ol/source/Vector').default} source */
export function cloneVectorSourceFeatures(source) {
  const features = source?.getFeatures?.() ?? [];
  return features.map(feature => feature.clone());
}
